import { render, staticRenderFns } from "./CostochondralPain.vue?vue&type=template&id=5dba20d6&scoped=true"
import script from "./CostochondralPain.vue?vue&type=script&lang=js"
export * from "./CostochondralPain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dba20d6",
  null
  
)

export default component.exports